import { lazy, Suspense, useState } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// Components
import { PdpSharedIconBubblePinterest } from '../PdpSharedIconBubbles/PdpSharedIconBubblePinterest';
import { PdpSharedIconBubbleFacebook } from '../PdpSharedIconBubbles/PdpSharedIconBubbleFacebook';
import { PdpSharedIconBubbleEmail } from '../PdpSharedIconBubbles/PdpSharedIconBubbleEmail';
import { PdpRespIconBubblePrint } from './PdpRespIconBubblePrint';

import styles from './PdpRespIconBubbles.scss';

const PdpRespShareIconTooltipLazy = lazy(() =>
    import(/* webpackChunkName: "PdpRespShareIconTooltip" */ './PdpRespShareIconTooltip')
);

function PdpRespIconBubblesComponent(props) {
    const { item, skuId, user, viewer, isClient } = props;
    const { isPublishedPrivate, isPublishedExclusive, isJewelry } = item || {};
    const { isPinterestShareEnabled, isFacebookShareEnabled, shareJewelryItemTooltip } = viewer;
    const isPublicPdp = !isPublishedExclusive && !isPublishedPrivate;

    const [isShareTooltipVisible, setIsShareTooltipVisible] = useState(false);
    const getEmailIcon = () => (
        <PdpSharedIconBubbleEmail item={item} user={user} viewer={viewer} skuId={skuId} />
    );

    return !isPublishedPrivate ? (
        <>
            {isPublicPdp && (
                <>
                    {isPinterestShareEnabled && <PdpSharedIconBubblePinterest item={item} />}
                    {isFacebookShareEnabled && <PdpSharedIconBubbleFacebook item={item} />}
                    {isClient && isJewelry && shareJewelryItemTooltip ? (
                        <div
                            className={styles.tooltipWrapper}
                            onMouseEnter={() => setIsShareTooltipVisible(true)}
                            onMouseLeave={() => setIsShareTooltipVisible(false)}
                        >
                            {isShareTooltipVisible && (
                                <Suspense fallback="">
                                    <PdpRespShareIconTooltipLazy />
                                </Suspense>
                            )}
                            {getEmailIcon()}
                        </div>
                    ) : (
                        getEmailIcon()
                    )}
                </>
            )}
            <PdpRespIconBubblePrint />
        </>
    ) : null;
}

PdpRespIconBubblesComponent.propTypes = {
    viewer: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
    skuId: PropTypes.string,
    isClient: PropTypes.bool,
};

export const PdpRespIconBubbles = createFragmentContainer(PdpRespIconBubblesComponent, {
    viewer: graphql`
        fragment PdpRespIconBubbles_viewer on Viewer {
            ...PdpSharedIconBubbleEmail_viewer
            ... @include(if: $fetchPdp) {
                isPinterestShareEnabled: isEnabledByLocale(featureName: "PINTEREST_SHARE")
                isFacebookShareEnabled: isEnabledByLocale(featureName: "FACEBOOK_SHARE")
                shareJewelryItemTooltip: featureFlag(feature: "shareJewelryItemTooltip")
            }
        }
    `,
    item: graphql`
        fragment PdpRespIconBubbles_item on Item {
            isPublishedPrivate
            isPublishedExclusive
            isJewelry
            ...PdpSharedIconBubblePinterest_item
            ...PdpSharedIconBubbleFacebook_item
            ...PdpSharedIconBubbleEmail_item
        }
    `,
    user: graphql`
        fragment PdpRespIconBubbles_user on User {
            ...PdpSharedIconBubbleEmail_user
        }
    `,
});
